import { createSlice } from "@reduxjs/toolkit";
import { NotificationStatusUpdates } from "../../components/notifications";
import { NOTIFICATION_EVENT_TYPES } from "../../helpers/notification-helpers";

export interface NotificationsState {
  isPending: boolean;
  notifications: NotificationStateType;
}

export type NotificationDataType = {
  eventName: string;
  eventType: NOTIFICATION_EVENT_TYPES;
  message: string;
  messageId: string;
  notificationTime: string;
  ruleName: string;
  status: "Unread" | "Read";
  title: string;
}

export type NotificationStateType = {
  lastKey?: string;
  results: NotificationDataType[];
};

const initialState: NotificationsState = {
  notifications: { lastKey: "", results: [] },
  isPending: false,
}

export const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    getAllNotifications: (state, payload) => { },
    saveAllNotifications: (state, actions) => {
      if (Object.keys(actions.payload || {}).length) {
        state.notifications = actions.payload;
      }
      else {
        state.notifications = { lastKey: "", results: [] }
      }
    },
    addNewNotification: (state, actions) => {
      const newNotification = actions.payload;
      const updated = [newNotification, ...state.notifications.results];
      state.notifications.results = updated;
    },
    updateAllNotifications: (state, actions) => {
      if (Object.keys(actions.payload || {}).length) {
        const updatedResults = (state.notifications.results || []).concat(actions.payload.results);
        state.notifications = { lastKey: actions.payload.lastKey, results: updatedResults };
      }
      else {
        state.notifications = { lastKey: "", results: [] }
      }
    },
    updatePendingNotifications: (state, actions) => {
      state.isPending = actions.payload;
    },
    markReadNotification: (state, actions) => { },
    markReadSuccess: (state, action) => {
      const messageIds = action.payload || [];
      state.notifications = {
        lastKey: state.notifications.lastKey,
        results: state.notifications.results?.map((notification: NotificationDataType) => {
          if (messageIds.includes(notification.messageId)) {
            return { ...notification, status: NotificationStatusUpdates.read };
          }
          return notification;
        })
      }
    },
    markAllAsRead: () => { },
    markAllAsReadSuccess: (state) => {
      state.notifications.results =
        state.notifications.results?.map((notification: any) => ({
          ...notification,
          status: NotificationStatusUpdates.read,
        }));
    },
  }
});

export const { addNewNotification, getAllNotifications, updatePendingNotifications, updateAllNotifications, saveAllNotifications, markReadNotification, markReadSuccess, markAllAsReadSuccess,
  markAllAsRead } =
  notificationSlice.actions;
export default notificationSlice.reducer;